import React from "react";

import './Lenders.css';

const Lenders = () => {
  return (
    <div>
      <h3>🚀 How it works for lenders</h3>
      <p>
        Lendify makes it easy for lenders to earn higher returns on their investments. Heres how it works:
      </p>
      <ol>
        <li>
          <strong>Register for an account:</strong> To start lending through the platform, you will need to create an account and complete the necessary registration and verification processes.
        </li>
        <li>
          <strong>Browse loan listings and place bids:</strong> The platform provides a user-friendly online marketplace where you can browse loan listings from borrowers and place bids on the loans that meet your investment criteria.
        </li>
        <li>
          <strong>Receive loan disbursements and track repayment progress:</strong> If your bid is accepted, you will receive the loan disbursement and begin earning interest on your investment. You can track the repayment progress of your loans through the dashboard.
        </li>
        <li>
          <strong>Earn returns on your investments:</strong> As the borrower repays the loan, you will earn returns on your investment. You can choose to reinvest your returns or withdraw them as needed.
        </li>
      </ol>
    </div>
  );
};

export default Lenders;
